import type {CaptionsStylePreset} from '@contentlab/types/captions';
import projectFetchers from '@/api/fetchers/content-studio/project';
import useReactQuery from '@/hooks/use-react-query';
import {CONTENT_LAB, CAPTIONS_STYLES} from '../consts';

function useCaptionsStylesQuery() {
  return useReactQuery<CaptionsStylePreset[]>({
    queryKey: [CONTENT_LAB, CAPTIONS_STYLES],
    queryFn: async () => {
      const response = await projectFetchers.getCaptionStylePresets();
      return response || [];
    },
  });
}

export default useCaptionsStylesQuery;
